// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1__1S","cls2":"FocusedNavView-cls2_1LO FocusedNavView-cls1__1S"};